import React from 'react';
import styles from './PageLink.module.css';

const PageLink=(props)=>{
	return (
		<div className={styles.link} onClick={props.open}>{props.label}</div>
	);
}

export default PageLink;